import { getDropdown } from '@/common/getDropdownList';
import { useQuery } from '@tanstack/react-query';

export const dropdownKeys = {
  all: ['dropdown'] as const,
  list: (flag: string, value1?: string, value2?: string, additionalValue1?: string) =>
    ['dropdown', { flag, value1, value2, additionalValue1 }] as const,
};

export const useDropdown = (
  flag: string,
  value1?: string,
  value2?: string,
  additionalValue1?: string,
  enabled = true,
) => {
  return useQuery({
    queryKey: dropdownKeys.list(flag, value1, value2, additionalValue1),
    queryFn: () => getDropdown({ flag, value1, value2, additionalValue1 }),
    enabled: enabled && !!flag,
  });
};
